<template>
  <div class="mySwitch">
    <!-- 显示所有图片 -->
    <div
      class="image-row"
      ref="imageRow"
      :style="{
        transform: `translateX(${-imageOffset + transformX}px)`,
        transition: 'transform 1.2s ease',
      }"
    >
      <img
        v-for="item in navItems"
        :key="item.id"
        :class="{ highlighted: currentItem && item.id === currentItem.id }"
        style="width: 931px; height: 568px"
        :src="item.url"
        alt=""
      />
    </div>
    <!-- 显示当前选中项的文字信息 -->
    <div class="slider-container">
      <!-- 左箭头 -->
      <div class="menu_direction">
        <div
          class="arrow left"
          @click="moveLeft"
          :style="{
            opacity: currentIndex === 0 ? 0.3 : 1,
            display: currentIndex === 0 ? 'none' : 'block',
          }"
        >
          <i class="el-icon-arrow-left"></i>
        </div>
      </div>
      <!-- 外部容器，固定宽度并溢出隐藏 -->
      <div class="outer-box" ref="outerBox">
        <!-- 内部容器，根据数据渲染 -->
        <div
          class="inner-box"
          ref="innerBox"
          :style="{
            transform: `translateX(-${titleOffset}px)`,
            transition: 'transform 0.3s ease',
          }"
        >
          <div
            v-for="item in navItems"
            :key="item.id"
            class="item"
            :class="{ active: currentItem && item.id === currentItem.id }"
            @click="selectItem(item)"
          >
            {{ item.title }}
          </div>
        </div>
      </div>
      <!-- 右箭头 -->
      <div class="menu_direction">
        <div
          class="arrow right"
          @click="moveRight"
          :style="{
            opacity: canScrollRightForTitle() ? 1 : 0.3,
            display: canScrollRightForTitle() ? 'block' : 'none',
          }"
        >
          <i class="el-icon-arrow-right"></i>
        </div>
      </div>
    </div>
    <div class="SwitchText" v-if="currentItem">{{ currentItem.msg }}</div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      navItems: [
        {
          id: "001",
          title: "镜头测量与定位流程",
          msg: "5分钟自动计算完成测量得到的镜头数据文件，将三维世界的虚拟摄影机与现场真实摄影机坐标完全对齐无偏差",
          url: "https://download.hecoos.com/enlightv/2025-17/37f549101ac217def309cf249ff30e36.png",
        },
        {
          id: "002",
          title: "延迟校准",
          msg: "测量摄影机延迟、媒体延迟，以及手动调整跟踪延迟，可以让屏幕画面和扩展画面完全同步，不出现卡顿和撕裂等画面瑕疵。",
          url: "https://download.hecoos.com/enlightv/2025-17/bfadae3a04c9937fddfdbedf990bc4c8.png",
        },
        {
          id: "003",
          title: "色彩校正",
          msg: "通过比较摄影机拍摄LED屏幕和原始输入的色彩，自动计算校色文件，实现屏内画面与扩展画面颜色的准确统一。",
          url: "https://download.hecoos.com/enlightv/2025-17/7e6c8a04ff7f81a12ff5bca98b38bbb2.png",
        },
        {
          id: "004",
          title: "多机位切换",
          msg: "当追踪系统数量与摄影机一对一匹配时，导播可根据需要在各追踪机位间无缝、适时切换拍摄画面，以表达丰富多样的视觉语言。",
          url: "https://download.hecoos.com/enlightv/2025-17/ccac8c851186e55acae1dc6ac1d105f7.png",
        },
        {
          id: "005",
          title: "引擎关卡/序列管理",
          msg: "将Server-C服务器的时间线上添加的多个虚拟场景节目与虚幻引擎中的各个场景关卡一一对应，实现随时播控/触发虚拟场景中的序列动画。",
          url: "https://download.hecoos.com/enlightv/2025-17/23207610ab5776b51566e965a4053b44.png",
        },
        {
          id: "006",
          title: "虚拟与现实灯光联调控制",
          msg: "以虚拟场景的灯光配置方案来构建真实影棚的灯光布局，hecoos通过ART-NET协议实现真实灯具的直接控制，达到虚拟与现实灯光同步联动。",
          url: "https://download.hecoos.com/enlightv/2025-17/be90db821f444481cb55fef8a09dbce3.png",
        },
        {
          id: "007",
          title: "Rivermax集群渲染",
          msg: "内视锥渲染画面与集群中的其他渲染节点共享，避免各节点的渲染资源浪费，多节点合理分工使画面质量更高、更流畅。使用SMPTE 2110同步策略对每个渲染节点进行帧锁定，确保虚幻引擎输出与摄影机保持同步。",
          url: "https://download.hecoos.com/enlightv/2025-35/f64b3aac4995550b7bdbd48ce58440b1.png ",
        },
      ],
      currentIndex: 0,
      offset: 0,
      visibleItems: 0,
      currentItem: null,
      totalWidth: 0,
      imageOffset: 0,
      titleOffset: 0,
      titleWidths: [],
      transformX: 0,
      marginWidth: 40, // 标题项间距
      safetyMargin: 10, // 修改：新增安全边距，防止边缘文字被切
    };
  },
  mounted() {
    this.$nextTick(() => {
      if (this.$refs.innerBox && this.$refs.outerBox) {
        this.currentItem = this.navItems[0];
        this.calculateTitleWidths();
        this.calculateVisibleItemsForTitle();
        this.calculateTotalWidthForTitle();
        this.centerSelectedImage();
        this.centerSelectedTitle();
        let number = Math.floor(this.navItems.length / 2);
        let transformX = 1111 * number - 931 / 3;
        this.transformX = transformX;
      }
    });
  },
  methods: {
    moveLeft() {
      if (this.currentIndex > 0) {
        this.currentIndex--;
        const step = this.titleWidths[this.currentIndex] + this.marginWidth;
        this.titleOffset -= step;
        // 确保偏移量不小于0
        this.titleOffset = Math.max(0, this.titleOffset);
        // 重新计算可见项
        this.calculateVisibleItemsForTitle();
      }
    },
    moveRight() {
      if (this.currentIndex < this.navItems.length - 1) {
        this.currentIndex++;
        const step = this.titleWidths[this.currentIndex] + this.marginWidth;
        const visibleWidth = this.getVisibleWidth();
        this.titleOffset += step;
        // 修改：优化右移边界判断，增加安全边距
        this.titleOffset = Math.min(
          this.titleOffset,
          this.totalWidth - visibleWidth + this.safetyMargin
        );
        // 重新计算可见项
        this.calculateVisibleItemsForTitle();
      }
    },
    selectItem(item) {
      const prevIndex = this.currentIndex;
      this.currentItem = item;
      this.currentIndex = this.navItems.findIndex((i) => i.id === item.id);

      // 使用 setTimeout 延迟执行图片切换逻辑
      setTimeout(() => {
        // 计算图片偏移量
        const itemWidth = 931 + 80;
        const targetImageIndex = this.currentIndex;
        const visibleWidth = this.getVisibleWidth();
        const totalItems = this.navItems.length;
        let targetOffset = 0;

        if (totalItems <= this.visibleItems) {
          // 所有图片都可见，将选中图片居中
          targetOffset = (visibleWidth - itemWidth) / 2;
        } else {
          // 计算选中图片在容器中的位置
          targetOffset =
            targetImageIndex * itemWidth - (visibleWidth - itemWidth) / 2 - 62;
          // 边界处理
          targetOffset = Math.max(
            0,
            Math.min(
              targetOffset,
              (totalItems - 1) * itemWidth - visibleWidth + itemWidth
            )
          );
        }
        this.imageOffset = targetOffset;
        // 计算标题偏移量
        const itemWidthTitle = this.titleWidths[this.currentIndex];
        let targetOffsetTitle = 0;
        for (let i = 0; i < this.currentIndex; i++) {
          targetOffsetTitle += this.titleWidths[i] + this.marginWidth;
        }

        targetOffsetTitle = Math.max(
          0,
          Math.min(
            targetOffsetTitle,
            this.totalWidth - visibleWidth + itemWidthTitle
          )
        );
        const centerOffset =
          targetOffsetTitle - (visibleWidth - itemWidthTitle) / 2;
        this.titleOffset = centerOffset;

        this.centerSelectedTitle();
        // 重新计算可见项，确保布局正确
        this.calculateVisibleItemsForTitle();
      }, 200);
    },
    calculateTitleWidths() {
      const titles = this.$refs.innerBox.querySelectorAll(".item");
      this.titleWidths = Array.from(titles).map((title) => title.offsetWidth);
    },
    calculateVisibleItemsForTitle() {
      if (this.$refs.innerBox && this.$refs.outerBox) {
        const outerBoxWidth = this.$refs.outerBox.offsetWidth;
        let totalWidth = 0;
        let visibleCount = 0;
        const items = this.$refs.innerBox.children;
        for (let i = 0; i < items.length; i++) {
          totalWidth += this.titleWidths[i];
          if (i > 0) {
            totalWidth += this.marginWidth;
          }
          // 修改：增加安全边距判断，避免计算时超出容器
          if (totalWidth <= outerBoxWidth + this.safetyMargin) {
            visibleCount++;
          } else {
            break;
          }
        }
        this.visibleItems = visibleCount;
      }
    },
    calculateTotalWidthForTitle() {
      let total = 0;
      for (let i = 0; i < this.titleWidths.length; i++) {
        total += this.titleWidths[i];
        if (i > 0) {
          total += this.marginWidth;
        }
      }
      this.totalWidth = total;
    },
    getVisibleWidth() {
      return this.$refs.outerBox ? this.$refs.outerBox.offsetWidth : 0;
    },
    canScrollRightForTitle() {
      // 修改：判断是否还能右滚时增加安全边距
      return (
        this.titleOffset <
        this.totalWidth - this.getVisibleWidth() + this.safetyMargin
      );
    },
    centerSelectedImage() {
      const visibleWidth = this.getVisibleWidth();
      const itemWidth = 931 - 80; // 图片宽度加上右边距
      const itemIndex = this.currentIndex;
      const totalItems = this.navItems.length;
      let targetOffset = 0;

      if (totalItems <= this.visibleItems) {
        // 所有图片都可见，将选中图片居中
        targetOffset = (visibleWidth - itemWidth) / 2;
      } else {
        // 计算选中图片在容器中的位置
        targetOffset = itemIndex * itemWidth - (visibleWidth - itemWidth) / 2;
        // 边界处理
        targetOffset = Math.max(
          0,
          Math.min(
            targetOffset,
            (totalItems - 1) * itemWidth - visibleWidth + itemWidth
          )
        );
      }

      this.offset = targetOffset;
      this.imageOffset = targetOffset;
    },
    centerSelectedTitle() {
      const visibleWidth = this.getVisibleWidth();
      const itemIndex = this.currentIndex;
      const itemWidth = this.titleWidths[itemIndex];
      let targetOffset = 0;
      for (let i = 0; i < itemIndex; i++) {
        targetOffset += this.titleWidths[i] + this.marginWidth;
      }

      // 计算让选中项居中的偏移量
      let centerOffset = targetOffset - (visibleWidth - itemWidth) / 2;

      // 修改：优化边界处理，增加安全边距防止文字被切
      const maxOffset = this.totalWidth - visibleWidth + this.safetyMargin;
      centerOffset = Math.max(0, Math.min(centerOffset, maxOffset));
      this.titleOffset = centerOffset;
    },
  },
  watch: {
    "$el.clientWidth": {
      handler() {
        this.calculateTitleWidths();
        this.calculateVisibleItemsForTitle();
        this.calculateTotalWidthForTitle();
        this.centerSelectedImage();
        this.centerSelectedTitle();
      },
      immediate: false,
    },
  },
};
</script>

<style scoped>
.mySwitch {
  background-color: #000;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: #818186;
}

.slider-container {
  display: flex;
  align-items: center;
  position: relative;
  width: 970px;
  margin-top: 50px;
}
.menu_direction {
  width: 40px;
  height: 46px;
}
.arrow {
  color: #fff;
  cursor: pointer;
  padding: 10px;
  font-size: 20px;
  user-select: none;
}

.outer-box {
  /* 修改：使用max-width替代固定width，增加灵活性 */
  width: 100%;
  max-width: 1000px;
  overflow: hidden;
  border-bottom: 0.1px #383838 solid;
}

.inner-box {
  display: flex;
  transition: transform 0.3s ease;
  /* //增加额外右内边距，防止最后一项紧贴边缘 */
  padding-right: 20px;
}

.item {
  padding: 10px 0;
  margin: 0 19px;
  box-sizing: border-box;
  cursor: pointer;
  font-size: 20px;
  white-space: nowrap;
  transition: color 0.3s ease, border-bottom 0.3s ease;
  /* // 修改：强制盒模型计算方式，避免宽度偏差 */
  box-sizing: content-box;
}

.item.active {
  color: #fff;
  border-bottom: 2px solid #cccccc;
}

.SwitchText {
  width: 850px;
  height: 150px;
  text-align: center;
  margin-top: 50px;
  font-size: 20px;
  transition: opacity 1s ease, visibility 0.3s ease;
}

.image-row {
  display: flex;
  flex-direction: row;
  transition: transform 0.5s ease;
  gap: 80px;
  padding-top: 50px;
}

.highlighted {
  filter: brightness(1);
  transition: filter 1.5s ease;
}

img:not(.highlighted) {
  filter: brightness(0.5);
}
</style>
